// firebase
import { db } from "config/firebase";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";

// A ---------------------------------------------------------------------- M

const getTag = async (tagId) => {
  try {
    const tagRef = doc(db, "tagsdata", tagId);
    const tagSnapshot = await getDoc(tagRef);

    if (!tagSnapshot.exists()) {
      console.log("Databox not found.");
      return {};
    }

    const tagData = tagSnapshot.data();

    const targetsRef = collection(tagRef, "targets");
    const targetsSnapshot = await getDocs(targetsRef);

    const targets = targetsSnapshot.docs.map((targetDoc) => {
      const { name, prototype, prototype_meta } = targetDoc.data();

      return {
        ...(name && { name }),
        ...(prototype && { prototype }),
        ...(prototype_meta && { prototype_meta }),
      };
    });

    return {
      ...tagData,
      id: tagSnapshot.id,
      targets,
    };
  } catch (error) {
    console.error(`Error in getTag for tagID ${tagId}:`, error);
    return {};
  }
};

export default getTag;
